import { render, staticRenderFns } from "./BbeeAccesosDirectosQ.vue?vue&type=template&id=24d3b836"
import script from "./BbeeAccesosDirectosQ.vue?vue&type=script&lang=js"
export * from "./BbeeAccesosDirectosQ.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports